'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function getDateDiff(resolution, date, today = new Date()) {
  return Math.floor((today.getTime() - date.getTime()) / resolution);
}

exports.getDateDiff = getDateDiff;
